export default __webpack_public_path__ + "static/media/kapp-logo.2ed4dcfa.png";